import cx from 'classnames';
import { t } from 'i18next';
import { FC } from 'react';
import { usePushNotification } from '../../scripts/hooks/usePushNotification';
import { Link } from '../link';

type TCoveragePushUpsellProps = {
  className?: string;
  compact?: boolean;
  buttonOnly?: boolean;
};

export const CoveragePushUpsell: FC<TCoveragePushUpsellProps> = ({ className, compact = false, buttonOnly = false }) => {
  const { isSupported, isInitialized, permissionState, subscription, isLoading, subscribe } = usePushNotification();

  if (!isSupported || !isInitialized || subscription) {
    return null;
  }

  const isDenied = permissionState === 'denied';

  // Gradient button style matching the addon download button
  if (buttonOnly) {
    if (isDenied) {
      return null;
    }

    return (
      <button
        className={cx('slds-button slds-button--raiderio-gradient slds-size--1-of-1 slds-text-heading--x-small', className)}
        onClick={subscribe}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <i className="fa fa-spinner fa-spin slds-m-right--x-small" />
            {t('settings:push-notifications.enabling')}
          </>
        ) : (
          <>
            <i className="fa fa-bell slds-m-right--x-small" />
            {t('settings:push-notifications.coverage-upsell.masthead-cta')}
          </>
        )}
      </button>
    );
  }

  return (
    <div className={className}>
      <div
        className={compact ? 'rio-alert-v2 rio-alert-v2--info' : 'rio-alert-v2 rio-alert-v2--info slds-p-around--small'}
      >
        <i className="rio-alert-v2__icon fa fa-bell" />
        <div className="rio-alert-v2__content">
          <p className="rio-alert-v2__message">{t('settings:push-notifications.coverage-upsell.title')}</p>
          <p className={compact ? 'text-muted slds-m-top--xx-small' : 'text-muted slds-m-top--x-small'}>
            {t(
              isDenied
                ? 'settings:push-notifications.coverage-upsell.blocked-body'
                : 'settings:push-notifications.coverage-upsell.body'
            )}
          </p>
          <div className="slds-m-top--small">
            {isDenied ? (
              <Link to="/settings/notifications" className="slds-button slds-button--neutral slds-button--small">
                <i className="fa fa-sliders slds-m-right--x-small" />
                {t('settings:push-notifications.coverage-upsell.manage')}
              </Link>
            ) : (
              <button
                className="slds-button slds-button--brand slds-button--small"
                onClick={subscribe}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <i className="fa fa-spinner fa-spin slds-m-right--x-small" />
                    {t('settings:push-notifications.enabling')}
                  </>
                ) : (
                  <>
                    <i className="fa fa-bell slds-m-right--x-small" />
                    {t('settings:push-notifications.coverage-upsell.cta')}
                  </>
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
